import { render, staticRenderFns } from "./SalesVariation.vue?vue&type=template&id=a4966c18&scoped=true&"
import script from "./SalesVariation.vue?vue&type=script&lang=js&"
export * from "./SalesVariation.vue?vue&type=script&lang=js&"
import style0 from "./SalesVariation.vue?vue&type=style&index=0&id=a4966c18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4966c18",
  null
  
)

export default component.exports